import ModalPortal from '@/components/ModalPortal/ModalPortal';
import config from '@/config';
import { UseFormState } from '@/hooks/useForm/interfaces';
import { useSubmitJobAlert } from '@/hooks/useSubmitJobAlert/useSubmitJobAlert';
import React from 'react';
import { ButtonSubmitState } from '../ButtonSubmit/consts';
import JobAlertModalContent from '../JobAlertModalContent/JobAlertModalContent';

const JobAlertModal = () => {
  const [buttonSubmitState, setButtonSubmitState] =
    React.useState<ButtonSubmitState>(ButtonSubmitState.Initial);

  const handleError = () => {
    setButtonSubmitState(ButtonSubmitState.Fail);

    // allow retry after a delay
    setTimeout(() => {
      setButtonSubmitState(ButtonSubmitState.Initial);
    }, 2000);
  };
  const handleSuccess = () => {
    setButtonSubmitState(ButtonSubmitState.Success);
  };

  const { sendData, FrcCaptchaComponent } = useSubmitJobAlert({
    onError: handleError,
    onSuccess: handleSuccess,
  });

  const handleSubmit = (state: UseFormState) => {
    if (buttonSubmitState === ButtonSubmitState.Initial) {
      setButtonSubmitState(ButtonSubmitState.Pending);
      sendData({
        email: state.email,
        timeType: state.timeType,
        categories: state.categories,
        token: state.token,
        apiBaseUrl: config.api.baseUrl,
      });
    }
  };

  return (
    <ModalPortal id="job-alert" variant="shade" disableCloseIcon={true}>
      <JobAlertModalContent
        onSubmit={handleSubmit}
        buttonSubmitState={buttonSubmitState}
      />
      <FrcCaptchaComponent />
    </ModalPortal>
  );
};

export default JobAlertModal;
